module.exports = __webpack_public_path__ + "static/media/Mask Group 24.c06055a6.svg";